import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLocal } from '../utils/localStorageOps';

export const ZoopRoute = ({ children }) => (
    getLocal('zoop_id') ? (
      children
    ) :
    (
      <Navigate to="/cadastro/passo2" />
    )
);